export default "__VITE_ASSET__D4Zu7zxG__"